export default {
  LOGGED_OUT_USER_MAX_POINTS: 3,
  LOGGED_OUT_USER_STARTING_LEVEL: 1,
};
